import getPageTitleKey from "./helpers/getPageTitleKey";
import usePurchases from "../../hooks/usePurchases";
import { memo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { SelectedOptionE } from "../../models/enums";
import type { PackageTypeRouteT, PurchaseParamsT } from "../../models/models";

import styles from "./styles.module.scss";

/**
 * Page title depends on URL parameter "packageType"
 * and URL parameter periodType
 * or selected option, which overrides URL parameter.
 */

const PurchasePageTitle = memo(() => {
  const { packageType: packageTypeUrlParam, periodType: periodTypeUrlParam } =
    useParams<PurchaseParamsT>();
  const { getTextByKey } = useContent();
  const { jumboCodeQuantity } = usePurchases();
  const [searchParams] = useSearchParams();
  const packageTypeSearchParam = searchParams.get("packageType") || "";
  const periodTypeSearchParam = searchParams.get("periodType") || "";

  // Select package type from URL parameter or search parameter (if it is checkout page)
  const packageType: PackageTypeRouteT = (packageTypeSearchParam ||
    packageTypeUrlParam) as PackageTypeRouteT;
  // Select period type from URL parameter or search parameter (if it is checkout page)
  const periodType = periodTypeSearchParam || periodTypeUrlParam;

  // Calculate page title key for translation
  const titleKey = getPageTitleKey(
    packageType!,
    (packageType === "pay-as-you-go"
      ? jumboCodeQuantity || ""
      : periodType!) as SelectedOptionE
  );

  return (
    <div className={`${styles.wrapper} test`}>
      <h1>{getTextByKey(titleKey)}</h1>
      <div className="title-divider" /*Style definition from _global.scss*/ />
    </div>
  );
});

export default PurchasePageTitle;
